// Implements: .claude/skills/rehaut-design/ui_kits/rehaut-pacientes/primitives.jsx (TypeBadge)
// See: .claude/skills/rehaut-design/HANDOFF.md
'use client';

/**
 * Patient type as a 2-letter "M·S" pair in Geist Mono. Each letter is
 * full opacity if the patient has that type, and dimmed (0.18) if not.
 * No pill, no fill — the brief explicitly demoted pills for type.
 *
 * Accepts `string[]` from `Patient.patient_type` ('medical'/'spa'/...).
 * Unrecognized strings are ignored.
 */
export function TypeBadge({ types }: { types: string[] }) {
  const hasMedical = types.includes('medical');
  const hasSpa = types.includes('spa');
  return (
    <span
      style={{
        display: 'inline-flex',
        gap: '2px',
        fontFamily: 'var(--font-mono)',
        fontSize: '10.5px',
        color: 'var(--ink-3)',
        letterSpacing: '0.5px',
        flexShrink: 0,
      }}
      aria-label={`Tipo: ${[hasMedical && 'Médico', hasSpa && 'Spa'].filter(Boolean).join(' y ') || 'sin tipo'}`}
    >
      <span style={{ opacity: hasMedical ? 1 : 0.18 }}>M</span>
      <span style={{ color: 'var(--ink-5)' }}>·</span>
      <span style={{ opacity: hasSpa ? 1 : 0.18 }}>S</span>
    </span>
  );
}
